import styles from './login-basic-box.scss';
import React, { PropsWithChildren } from 'react';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

// Both modifiers are optional presentation flags the auth pages already pass;
// typing them changes nothing at runtime (the JSX below is untouched) and is what
// lets `tsc --noEmit` see this component and its callers as sound. Without the
// type, `props.isResetBoxMobileSize` was a TS2339 here and every caller passing it
// was a TS2322 there (batch 004 type gate).
type LoginBasicBoxProps = PropsWithChildren<{
  isResetBoxMobileSize?: boolean;
  innerBoxPadding?: boolean;
}>;

const LoginBasicBox = (props: LoginBasicBoxProps) => (
  <div className={styles.container}>
    <main
      className={cx([
        'box',
        {
          resetBoxMobileSize: props.isResetBoxMobileSize,
          innerBoxPadding: props.innerBoxPadding,
        },
      ])}>
      {props.children}
    </main>
  </div>
);

export default LoginBasicBox;
